import api from './HttpService';
import { DASHBOARD } from '../configs/ApiActionUrl';

async function getAll(client, department, currency, rangeDate) {
  let query = '?';

  if (client) {
    query += `&client=${client}`;
  }
  if (department) {
    query += `&department=${department}`;
  }

  if (currency) {
    query += `&currency=${currency}`;
  }

  if (rangeDate) {
    const { startDate, endDate } = rangeDate;
    if (startDate && endDate) {
      query += `&from_date=${startDate}&to_date=${endDate}`;
    }
  }

  try {
    const res = await api.get(DASHBOARD.GET_ALL + query);
    return res;
  } catch (error) {
    // Handle errors here
    return error; // Rethrow the error to propagate it further
  }
}

async function getFilterOptions() {
  const res = await api.get(`${DASHBOARD.FILTER_OPTIONS}`);
  return res;
}

const DashboardService = {
  getAll,
  getFilterOptions
};

export default DashboardService;
